import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../services/config/config.service';

@Pipe({ name: 'appIsoDateStringMomentFromConfig' })
export class IsoDateStringMomentFromConfigPipe implements PipeTransform {
    constructor(private configService: ConfigService) {
    }

    transform(value: any, property: string): string | null {
        const format = this.configService.config[property] as string;
        if (format === undefined) {
            throw new Error(`Property "${property}" is not defined in config.json, RawConfig or Config!`);
        }
        const d = moment.parseZone(value);
        return d.format(format);
    }
}
